// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentRejectDetails {
    static getAttributeTypeMap() {
        return DigitalpaymentRejectDetails.attributeTypeMap;
    }
}
DigitalpaymentRejectDetails.discriminator = undefined;
DigitalpaymentRejectDetails.additionalProperties = false;
DigitalpaymentRejectDetails.attributeTypeMap = [
    {
        "name": "rejectAmount",
        "baseName": "rejectAmount",
        "type": "number"
    },
    {
        "name": "rejectDate",
        "baseName": "rejectDate",
        "type": "Date"
    },
    {
        "name": "rejectReasonCode",
        "baseName": "rejectReasonCode",
        "type": "string"
    },
    {
        "name": "rejectReasonDescription",
        "baseName": "rejectReasonDescription",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentRejectDetails.js.map